import { Pipe, PipeTransform } from '@angular/core';
import { EmailTag } from '@workspace/data-types';
import { CoreNiceLabelUtils } from '../core-nice-label.utils';

@Pipe({
  name: 'emailTagDisplay',
})
export class EmailTagDisplayPipe implements PipeTransform {
  transform(tag: EmailTag): string {
    return emailTagDisplayTransform(tag);
  }
}

export function emailTagDisplayTransform(value: EmailTag) {
  return CoreNiceLabelUtils.emailTag(value);
}
